import React, { useEffect, useState } from "react";
import axiosConfig from "../../Service/AxiosConfig";
import "./QuoteModal.css";
import { IoIosCloseCircleOutline } from "react-icons/io";
const QuoteModal = ({ booking, onClose, onSuccess }) => {
  const [quoteData, setQuoteData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [accepting, setAccepting] = useState(false);

  const leadId = booking?.lead?.id;

  useEffect(() => {
    if (!leadId) return;
    setLoading(true);

    axiosConfig
      .get(`/accounts/leads/${leadId}/quote-items/`)
      .then((res) => setQuoteData(res.data))
      .catch(() => console.log("Failed to fetch quote details"))
      .finally(() => setLoading(false));
  }, [leadId]);

  const handleAccept = async () => {
    if (!leadId || accepting) return;
    setAccepting(true);

    try {
      await axiosConfig.post(`/accounts/accept-patient/${leadId}/`);
      onClose();
      onSuccess();
    } catch (err) {
      onSuccess("error", err?.response?.data?.message);
    } finally {
      setAccepting(false);
    }
  };

  const items = quoteData?.items || [];

  return (
    <div className="quote-modal-backdrop">
      <div className="quote-modal">
        <button className="quote-close" onClick={onClose} disabled={accepting}>
          <IoIosCloseCircleOutline size={30} style={{ color: "#fff" }} />
        </button>

        {loading ? (
          <p className="quote-loading">Loading quote…</p>
        ) : (
          <>
          <div className="quote-table-wrapper">
            <table className="quote-table">
              <thead>
                <tr>
                  <th>Service</th>
                  <th>Start</th>
                  <th>End</th>
                  <th>Duration</th>
                  <th>Adjustment</th>
                  <th>Final Price</th>
                </tr>
              </thead>

              <tbody>
                {items.map((item) => (
                  <tr key={item.quote_item_id}>
                    <td>
                      <small className="sub-text">{item.service_name}</small>
                      <div className="sub-text">
                        {item.resource_category} • {item.service_type}
                      </div>
                    </td>
                    <td>{item.start_date}</td>
                    <td>{item.end_date}</td>
                    <td>{item.duration_days} days</td>
                    <td>₹{item.price_adjustment.toFixed(2)}</td>
                    <td className="price">₹{item.final_price.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
</div>
            <div className="quote-summary">
              <div>
                Total Amount:
                <span>₹{quoteData?.total_amount?.toFixed(2)}</span>
              </div>
              <div>
                Net Amount:
                <span>₹{quoteData?.net_amount?.toFixed(2)}</span>
              </div>
            </div>

            <div className="quote-footer">
              <button
                className="accept-btn"
                onClick={handleAccept}
                disabled={accepting}
              >
                {accepting ? "Accepting..." : "Accept Now"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default QuoteModal;
